import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, VideoIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-brand-dark" data-id="element-100" data-mp="4n1jem0cu2pv">
      <div className="mx-auto max-w-letter px-4 pt-5 pb-6 text-center sm:px-6 sm:pt-7" data-id="element-101" data-mp="4jvw9cbadaws">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full bg-gold px-3 py-1 text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-brand-deep sm:text-xs" data-id="element-102" data-mp="127ect9b6vhbc">
          <VideoIcon size={13} aria-hidden="true" data-id="element-103" data-mp="3d21t5zvq8oos" />
          Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.04
      }} className="mt-2.5 font-display text-[1.6rem] uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-104" data-mp="381e3bhj8idw5">
          El sistema completo para aprender{' '}
          <span className="text-gold" data-id="element-105" data-mp="39cpcutwbfj2d">Cámaras de Seguridad y Alarmas</span>{' '}
          desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-2.5 max-w-xl text-sm font-medium leading-snug text-ink-onDarkMuted sm:text-base" data-id="element-106" data-mp="30ib0p0730onh">
          Aprendé una habilidad técnica, comprendé cómo funciona una instalación
          y abrí nuevas oportunidades — sin perderte entre cientos de videos y
          tutoriales.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.22,
        ease: EASE,
        delay: 0.12
      }} className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-white px-3 py-1.5 text-[0.7rem] font-extrabold uppercase leading-tight tracking-tight text-brand sm:text-sm" data-id="element-107" data-mp="2lkqx9xpu31jf">
          <VideoIcon size={14} className="flex-shrink-0" aria-hidden="true" data-id="element-108" data-mp="ici0zaloos78" />
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.16
      }} className="mt-3 block overflow-hidden rounded-xl border-4 border-gold bg-white transition-transform duration-200 ease-soft hover:scale-[1.01]" data-id="element-109" data-mp="1b1ffr3qos6v8">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="w-full" data-id="element-110" data-mp="x3h1rzga2cg9" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-111" data-mp="3lqui5yd6ip9t">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-112" data-mp="1x7hvvdunc30v">
            Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.7rem] font-semibold text-ink-onDarkMuted sm:text-xs" data-id="element-113" data-mp="26a9a1lewpcw7">
            <span className="flex items-center gap-1.5" data-id="element-114" data-mp="2b2aisxcv8lhh">
              <ZapIcon size={13} className="text-gold" aria-hidden="true" data-id="element-115" data-mp="2g0c0peyk2erd" />
              Acceso Digital Inmediato
            </span>
            <span aria-hidden="true" data-id="element-116" data-mp="2kxkj9gnm8kt5">•</span>
            <span className="flex items-center gap-1.5" data-id="element-117" data-mp="2p0h8vrbkph6l">
              <ShieldCheckIcon size={13} className="text-gold" aria-hidden="true" data-id="element-118" data-mp="2p10f4arv2h4s" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}